module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Cap-0d2f5c5616adf1d918cd1087ab961ae289f60de25051adf347f1d01916c31c3f.svg";